import type { User, PartnerSignupResult, SocialSignInInput, SocialSignInResult } from "@atlas/shared";
import { apiGet, apiPost } from "../lib/api-client";

export type { User };

export function fetchMe(): Promise<{ user: User }> {
  return apiGet("/auth/me");
}

export function login(data: { email: string; password: string }): Promise<{ user: User }> {
  return apiPost("/auth/login", data);
}

export function signup(data: {
  email: string;
  password: string;
  name: string;
  inviteCode?: string;
  /** Referrer's username from a /join/{username} link (spec 21). */
  referralCode?: string;
  turnstileToken?: string;
}): Promise<{
  user: User;
  betaClaim?: { ok: boolean; reason?: string; expiresAt?: string };
  /** Partner code outcome (ATL-134) when one was applied. */
  partner?: PartnerSignupResult;
  referral?: { ok: boolean };
}> {
  return apiPost("/auth/signup", data);
}

export function logout(): Promise<{ ok: boolean }> {
  return apiPost("/auth/logout");
}

export function forgotPassword(data: { email: string }): Promise<{ ok: boolean }> {
  return apiPost("/auth/forgot-password", data);
}

export function resetPassword(data: {
  token: string;
  password: string;
}): Promise<{ ok: boolean }> {
  return apiPost("/auth/reset-password", data);
}

export function resendVerification(): Promise<{ ok: boolean }> {
  return apiPost("/auth/resend-verification");
}

export function verifyEmail(data: {
  token: string;
}): Promise<{ ok: boolean; emailChanged: boolean; email: string | null }> {
  return apiPost("/auth/verify-email", data);
}

// ─── Sign in with Apple / Google (ATL-130) ───────────────────────────────────
// The provider's identity token from lib/social-sign-in.ts; the API verifies
// it and signs in, links by verified email, or creates the account.

export function socialSignIn(
  data: SocialSignInInput,
): Promise<SocialSignInResult & { partner?: PartnerSignupResult; referral?: { ok: boolean } }> {
  return apiPost("/auth/social", data);
}
